import { useCallback, useEffect, useMemo, useState } from "react";
import { getSubdomainByLocation } from "@functions/getSubDomainSalud";

const useAppOrigin = (app?:"operational" | "saludProx" | "reports") => {
    const [ appOrigin, setAppOrigin ] = useState<string| null>(null);
    
    const getDomain = useCallback(() => {
        const domain = getSubdomainByLocation(app);
        setAppOrigin(domain);
    },[app]);

    useEffect(() => {
        getDomain();
    }, [app, getDomain]);

    const requiredPlan = useMemo(() => {
        let requiredPlan = true;
        if(appOrigin === "hubio")
            requiredPlan = false;
        return requiredPlan;
    }, [appOrigin]);

    return { appOrigin, requiredPlan};
};

export default useAppOrigin;
